import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@monksflow/monks-ui';
import { ChevronDownIcon, FileTextIcon, UserIcon } from 'lucide-react';
import type { DownloadDropdownProps } from '../../model/audience-interview.types';
import { useTranslation } from 'react-i18next';

export function DownloadDropdown({ onDownload, isDownloading }: DownloadDropdownProps) {
  const { t } = useTranslation('audiences');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={isDownloading}>
          {isDownloading
            ? t('audienceInterview.downloadDropdown.exporting')
            : t('audienceInterview.downloadDropdown.download')}
          <ChevronDownIcon className="ml-1 size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem onClick={() => onDownload('conversation')}>
          <FileTextIcon className="mr-2 size-4" />
          {t('audienceInterview.downloadDropdown.conversationAsPdf')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onDownload('persona')}>
          <UserIcon className="mr-2 size-4" />
          {t('audienceInterview.downloadDropdown.personaAsPdf')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
